import React, { Fragment,useEffect } from "react";
import Header from "../components/header";
import PageTitle from "../components/pagetitle";
import BlogSingle4 from "../components/blogsingle4";
import Footer from "../components/footer";
import ScrollToTop from "react-scroll-to-top";
const ContactPage = () => {
    useEffect(()=>{window.scrollTo(0,0)})

  return (
    <Fragment>
      <Header />
      <PageTitle pageTitle={"BLOG DETAILS"} pagesub={"Blog Details"} />
      <BlogSingle4 />
      <Footer />
    </Fragment>
  );
};
export default ContactPage;